<template>
  <div style="background:#fff;">
    <div
      class="page_title"
      v-if="edit"
    >编辑医生入驻协议</div>
    <div
      class="page_title"
      v-else
    >添加医生入驻协议</div>
    <div class="container">
      <div class="essay">
        <div style="margin-bottom:20px">
          <el-input
            v-model="title"
            placeholder="请输入标题"
            maxlength="20"
            show-word-limit
          ></el-input>
        </div>

        <div style="width:100%;height:100%;">
          <wangeditor ref="editorBox" />
        </div>
        <div class="btnbox">
          <div>
            <el-button
              type="primary"
              round
              style="width:100px;margin-right:5px"
              @click="submit"
            >保存</el-button>

            <el-button
              plain
              round
              style="width:100px"
              @click="back"
            >退出</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import wangeditor from '../wangeditor';
import imgtext from '../../../api/imgtext';
export default {
  data() {
    return {
      title: '',
      edit: false
    };
  },
  components: {
    wangeditor
  },
  methods: {
    //发布
    submit() {
      if (!this.title) {
        this.$message.error('请填写标题');
        return false;
      }
      let content = this.$refs.editorBox.editor.txt.html();
      if (!content) {
        this.$message.error('请填写内容');
        return false;
      }

      let data = {
        title: this.title,
        content: content,
        art_id: 1
      };

      imgtext.saveArticleInfo(data).then((res) => {
        if (res.code == 0) {
          this.$message.success('保存成功');
          this.back();
        }
      });
    },
    //获取图文信息
    getDetail() {
      let art_id = 1;
      imgtext.getArticleInfo({ art_id }).then((res) => {
        if (res.code == 0) {
          let detail = res.data.info;
          this.title = detail.title;
          if (detail.content) {
            this.setDesc(detail.content);
            this.edit = true;
          }
        }
      });
    },
    //往编辑器里插入数据
    setDesc(text) {
      this.$refs.editorBox.editor.txt.html(text);
    },
    back() {
      history.back();
    }
  },
  created() {
    this.getDetail();
  }
};
</script>
<style lang="scss" scoped>
.container {
  min-height: calc(100vh - 120px);
  background: #fff;
}
.essay {
  width: 70%;
  margin: 20px auto 0;
  // padding-bottom: 20px;
}
.btnbox {
  width: 100%;
  height: 58px;
  border: solid 1px #cfcece;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 30px;
  box-sizing: border-box;
  background: #fff;
}
</style>
